import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import SecurityIcon from '@mui/icons-material/Security';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material';

interface ScanWarningDialogProps {
    onClose: () => void;
    open: boolean;
}

// Extracted informational dialog shown for unrecognized / unsupported tags
export function ScanWarningDialog({ onClose, open }: Readonly<ScanWarningDialogProps>) {
    return (
        <Dialog fullWidth maxWidth="xs" onClose={onClose} open={open}>
            <DialogTitle sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                <WarningAmberIcon color="warning" />
                Unrecognized Tag
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText sx={{ mb: 1 }} variant="body2">
                    The scanned code does not match a verified Renki tag. Possible reasons:
                </DialogContentText>
                <List dense disablePadding>
                    <ListItem>
                        <ListItemIcon>
                            <LinkOffIcon color="disabled" fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            primary="The tag has not been configured in Renki yet"
                            slotProps={{ primary: { variant: 'body2' } }}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <DoNotDisturbAltIcon color="error" fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            primary="The tag may be fraudulent or tampered"
                            slotProps={{ primary: { variant: 'body2' } }}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <SecurityIcon color="info" fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            primary="The tag belongs to another system (not Renki)"
                            slotProps={{ primary: { variant: 'body2' } }}
                        />
                    </ListItem>
                </List>
                <DialogContentText sx={{ mt: 2 }} variant="body2">
                    For your security: Only follow links from trusted tags. Avoid scanning unknown or suspicious
                    codes—they may pose a security risk.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} size="small" sx={{ textTransform: 'none' }} variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export type { ScanWarningDialogProps };
